import api from './api';

export interface CoverageResult {
  status: 'Available' | 'Unavailable';
  source: string;
}

export const locationsService = {
  checkCoverage: (lat: number, lng: number, category: string) =>
    api
      .post<CoverageResult>('/locations/coverage-check', { lat, lng, category })
      .then((r) => r.data),

  create: (data: {
    offerId: string;
    lat: number;
    lng: number;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    region?: string;
  }) => api.post('/locations', data).then((r) => r.data),
};
